import Api from "~/service/Api";

class ProviderRepository {
  fetch(query) {
    return Api.get("/providers", query);
  }

  create(data) {
    return Api.post("/providers", data);
  }

  fetchOne(providerId) {
    return Api.get(`/providers/${providerId}`);
  }

  update(providerId, data) {
    return Api.put(`/providers/${providerId}`, data);
  }
}

export default ProviderRepository;
